// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"386":"c4884d57","501":"09f3fdb7","538":"7f9a71d6"}[chunkId] + ".chunk.css";
};